module.exports = __webpack_public_path__ + "static/media/water-impact.df8622f9.png";